import { useAuthStore } from '../../../store/authStore';
import type { CalendarEventDto } from '../../../api/calendar';

/**
 * 「이 일정이 «내» 것인가」를 한 곳에서 판정한다 (2026-09-09 사용자 결정 「내 일정은 굵게」 ·
 * 2026-09-28 반영).
 *
 * ## ⭐ 판정은 «지어내지 않고» 이 레포의 관용구를 쓴다
 *
 * ```
 * CalendarPage.tsx  detailSnap.creatorId === String(myUserId)
 * ⇒ 같은 꼴을 쓴다. creatorId 는 문자열이고 store 의 id 는 숫자다
 * ```
 *
 * ## ⭐ 왜 «프롭»이 아니라 store 를 직접 읽나
 *
 * `EventCreatorAvatar.tsx` 머리말이 이미 못 박아 두었다 —
 * 「MonthView/TimeGridView/DayPopover/EventDetailModal 에 prop 을 새로 뚫지 않기 위함(회귀 안전)」.
 * `CalendarSidebar.tsx` 도 `useAuthStore` 를 직접 읽는다. 그 결정을 따른다.
 *
 * ## ⛔ 그리고 «두 벌»을 만들지 않으려고 여기에 둔다
 *
 * 월간 칩과 주간·일간 시간 블록이 «같은 판정»을 쓴다. 각 화면에 복사하면
 * 한쪽만 고쳐지는 날이 온다(이 레포가 여러 번 겪은 자리다).
 */
export function useMyUserId(): string | null {
  return useAuthStore((s) => (s.user?.id != null ? String(s.user.id) : null));
}

/** 내가 만든 일정인가. 로그인 정보가 없으면 «아니다»로 둔다(굵게 하지 않는다). */
export function isMineEvent(event: CalendarEventDto, myUserId: string | null): boolean {
  return myUserId != null && event.creatorId === myUserId;
}
